import React from 'react'

const Help = () => {
    return (
        <div>
        <div 
        style={{
            height:'100vh',
            textAlign:'center',
            display:'grid',
            placeItems:'center'
        
        }}>

            <h1>Follow Me on GitHub</h1>

        </div>
            
        </div>
    )
}

export default Help;
